import { Box, Button, Chip, Grid2, Tab, Tabs, Typography } from "@mui/material";
import PrimaryIcon from "Components/Common/PrimaryIcon";
import React, { useState } from "react";
import { ReactComponent as PeopleIcon } from "Assets/Icons/Home/PeopleIcon.svg";
import { ReactComponent as CoinIcon } from "Assets/Icons/Home/CoinIcon.svg";
import PrimarySlider from "Components/Common/PrimarySlider";
import { SwiperSlide } from "swiper/react";

const styles = (theme) => ({
  border: `1px solid ${theme.palette.border.blue}`,
  borderRadius: "8px",
  padding: "16px",
  display: "flex",
  flexDirection: "column",
  gap: "15px",
  "& .emptyMsg": {
    minHeight: "100px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  "& .assignmentBox": {
    border: `1px solid ${theme.palette.border.blue}`,
    borderRadius: "8px",
    padding: "16px",
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    cursor: "pointer",
    gap: "5px",
    "&:hover": {
      background: theme.palette.background.default,
    },
  },
});

const Practice = () => {
  const [currentTab, setCurrentTab] = useState(0);

  return (
    <Grid2 sx={styles}>
      <Box
        display={"flex"}
        justifyContent={"space-between"}
        alignItems={"center"}
      >
        <Typography fontWeight={500} variant="title">
          Practice
        </Typography>
        <Button variant="outlined">All Problems</Button>
      </Box>
      <Tabs
        className="tabs"
        type="button"
        value={currentTab}
        TabIndicatorProps={{ hidden: true }}
        onChange={(e, value) => setCurrentTab(value)}
      >
        <Tab label="Pick Where You Left" />
        <Tab label="Newly Unlocked" />
        <Tab label="Easy Picks" />
        <Tab label="Business Case" />
      </Tabs>
      <Grid2 width={"100%"}>
        {currentTab == "1" ? (
          <Box className="emptyMsg">
            <Typography>There are no problems to solve right now!</Typography>
          </Box>
        ) : (
          <PrimarySlider spacing={"15px"}>
            {[...Array(10)].map((item, i) => {
              return (
                <SwiperSlide key={i}>
                  <Grid2
                    key={`practice${i}`}
                    size={2}
                    className="assignmentBox"
                  >
                    <Box
                      display={"flex"}
                      justifyContent={"space-between"}
                      alignItems={"center"}
                    >
                      <Typography color="secondary.light">
                        Product Analytics{" "}
                      </Typography>
                      <Chip
                        variant="outlined"
                        color="success"
                        outlined
                        label="Easy"
                      />
                    </Box>
                    <Typography fontWeight={500}>RFM Clustering</Typography>
                    <Typography
                      display={"flex"}
                      alignItems={"center"}
                      gap="8px"
                    >
                      <PrimaryIcon height="16px" width="16px" icon={CoinIcon} />
                      50
                      <PrimaryIcon
                        height="12px"
                        width="16px"
                        icon={PeopleIcon}
                      />
                      1
                    </Typography>
                  </Grid2>
                </SwiperSlide>
              );
            })}
          </PrimarySlider>
        )}
      </Grid2>
    </Grid2>
  );
};

export default Practice;
